// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// eslint-disable-next-line import/no-extraneous-dependencies
import 'sweetalert2/dist/sweetalert2.min.css';
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueSessionStorage from 'vue-sessionstorage';
import VueSweetalert2 from 'vue-sweetalert2';
import store from './vuex/store';
import delayedNavigation from './common/utils/navigation';

import plugins from './config/plugins';
import theme from './config/theme';
import configRouter from './config/router';
import App from './App';


plugins(Vue, VueRouter);
theme(Vue);
Vue.use(VueSessionStorage);
Vue.use(VueSweetalert2);

/**
export const store = new Vuex.Store(vuexStore);
*/
const router = configRouter(VueRouter);
router.beforeEach((to, from, next) => {
  ga('set', 'page', to.fullPath);
  ga('send', 'pageview');
  next();
});

// delay navigation
Vue.prototype.$delayedNavigation = delayedNavigation;

// write a function to safely access a nested object in javascript, similar to lodash/get
Vue.prototype.$get = (obj, path, defValue) => {
  let value = obj;
  if (typeof path === 'string') {
    path = path.split('.');
  }
  for (let i = 0, l = path.length; i < l; i++) {
    value = value[path[i]];
    if (value === undefined) {
      return defValue;
    }
  }
  return value;
}


new Vue({ // eslint-disable-line no-new
  router,
  store,
  el: '#app',
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js